import { Grid, Skeleton } from "@mui/material";
import { type FunctionComponent } from "react";

export const BrandSelectionSkeleton: FunctionComponent = ({ ...restProps }) => {
    return (
        <Grid
            container
            columns={{
                lg: 12,
                md: 12,
                sm: 8,
                xl: 12,
                xs: 4,
            }}
            spacing={3}
            {...restProps}
        >
            <Grid item xs={8} sm={4} md={6} lg={4} xl={3}>
                <Skeleton height={116} />
            </Grid>

            <Grid item xs={8} sm={4} md={6} lg={4} xl={3}>
                <Skeleton height={116} />
            </Grid>

            <Grid item xs={8} sm={4} md={6} lg={4} xl={3}>
                <Skeleton height={116} />
            </Grid>

            <Grid item xs={8} sm={4} md={6} lg={4} xl={3}>
                <Skeleton height={116} />
            </Grid>
        </Grid>
    );
};
